import FormQuestionBackOffice from './form-question';

export default FormQuestionBackOffice;
